export const CHAT_TUTORIAL_STAGE = 'chatTutorialStage';
export const QUESTION_LIST_TUTORIAL_STAGE = 'questionListTutorialStage';
export const TOKEN = 'token';
export const USER_DATA = 'userData';
export const USER_LANG = 'userLng';
export const QUESTION_ID = 'QUESTION_ID';
export const UN_SENT_MESSAGE = 'unSentMessage';



// WEBPACK FOOTER //
// ./src/constants/cookieName.js